<template>
  <div class="main-layout">
    <LazyHydrate when-idle>
      <AppHeader />
    </LazyHydrate>

    <NavSections />

    <main class="main">
      <Nuxt />
    </main>

    <LazyHydrate when-idle>
      <ToTopButton />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <AppFooter />
    </LazyHydrate>

    <ClientOnly>
      <AppOverlay />
    </ClientOnly>

    <LazyHydrate when-idle>
      <ModalSocialEmailError />
    </LazyHydrate>

    <ClientOnly>
      <BigModal v-if="$route.query.hasOwnProperty('bigModal') && $route.query.bigModal">
        <RegAuthForgot />
      </BigModal>
    </ClientOnly>

    <LazyHydrate when-idle>
      <AppSidebar />
    </LazyHydrate>

    <LazyHydrate when-idle>
      <AppBurgerMenu />
    </LazyHydrate>

    <ClientOnly>
      <AppMessages v-if="isLoggedIn" />
    </ClientOnly>

    <ClientOnly>
      <ModalComponent />
    </ClientOnly>

    <ClientOnly>
      <BaseModalGlobal />
    </ClientOnly>

    <ClientOnly>
      <IntercomLoading />
    </ClientOnly>

    <ClientOnly>
      <NotifyToast />
    </ClientOnly>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LazyHydrate from 'vue-lazy-hydration'
import i18nHead from '~/util/i18n/i18nHead'
const AppMessages = () => import('@/components/App/AppMessages')
const AppBurgerMenu = () => import('@/components/App/AppBurgerMenu')
const AppSidebar = () => import('@/components/App/AppSidebar')
const ToTopButton = () => import('@/components/App/ToTopButton')
const AppHeader = () => import('@/components/App/AppHeader')
const AppFooter = () => import('@/components/App/AppFooter')
const AppOverlay = () => import('@/components/App/AppOverlay')
const BigModal = () => import('@/components/BigModal')
const RegAuthForgot = () => import('@/components/BigModal/RegAuthForgot')
const ModalSocialEmailError = () => import('@/components/Modal/ModalSocialEmailError')
const NavSections = () => import('~/components/Lobby/NavSections')
const BaseModalGlobal = () => import('@/components/Base/Modal/Global')
const IntercomLoading = () => import('@/components/IntercomLoading')
const NotifyToast = () => import('@/components/NotifyToast')

export default {
  name: 'MainLayout',
  components: {
    LazyHydrate,
    AppFooter,
    AppHeader,
    AppOverlay,
    AppMessages,
    AppSidebar,
    ToTopButton,
    AppBurgerMenu,
    BigModal,
    RegAuthForgot,
    ModalSocialEmailError,
    NavSections,
    BaseModalGlobal,
    IntercomLoading,
    NotifyToast,
  },
  async fetch() {
    await this.fetch_seoPage(this.$route.path)
  },
  head() {
    return {
      title: this.get_seoPage.title,
      ...i18nHead(this.$nuxtI18nHead({ addSeoAttributes: true }), { route: this.$route }),
      bodyAttrs: { class: 'theme-dark' },
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('seo', ['get_seoPage']),
  },
  mounted() {
    if (this.isLoggedIn) {
      this.$store.dispatch('user/PROFILE_INFO')
    }
  },
  created() {
    if (process.server) return
    if (!this.$route.query.redirected) return
    this.$newModal.openAuthOrRegister({ noOldQuery: true })
  },
  methods: {
    ...mapActions('seo', ['fetch_seoPage']),
  },
}
</script>

<style lang="scss" scoped>
.main {
  max-width: 100%;
  overflow: hidden;
  background-color: var(--general-bg-general);

  @include media(tablet-album) {
    min-height: 600px;
  }

  @include media(landscape) {
    min-height: 100px;
  }
}
</style>
